"use client"

import { BookDown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookDownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookDownIcon = component(Icon)({ as: BookDown })
